import * as z from 'zod';

// GET /3.0/feed/general-carousel
export const GeneralCarouselItemSchema = z.object({
  id: z.number(),
  content: z.string(),
  linkURL: z.string(),
  imageURL: z.string(),
  displayOrder: z.number(),
});

export const GeneralCarouselSchema = z.object({
  items: z.array(GeneralCarouselItemSchema).nullable(),
});

export type GeneralCarouselItem = z.infer<typeof GeneralCarouselItemSchema>;
export type GeneralCarousel = z.infer<typeof GeneralCarouselSchema>;
